// extracted by mini-css-extract-plugin
export default {"userAssignment_upperButtons":"UsersAssignment_userAssignment_upperButtons__EiKS0"};